import SectionHead from "../components/site/SectionHead";
import EMICalculator from "../components/site/EMICalculator";
import LeadForm from "../components/site/LeadForm";

export default function EmiPage() {
  return (
    <div data-testid="emi-page" className="container-site py-14 lg:py-20">
      <SectionHead eyebrow="EMI Calculator" title="Calculate Your Monthly EMI"
        subtitle="Use the sliders to model your loan. Calculations use the standard reducing-balance method. Final EMI and terms are determined by the lender." />
      <div className="mt-12"><EMICalculator /></div>
      <div className="mt-16"><LeadForm title="Ready to move forward? Tell us what you need." source="emi_calculator" /></div>
    </div>
  );
}
